export default "__VITE_ASSET__d0ba66a1__"